import { useMemo, useState } from 'react'

import { FormConfig } from '@workwave-tidal/core/form'

import { useTestEmailNotificationModal } from '@/components/modals/TestEmailNotificationModal'
import { useTestPhoneNotificationModal } from '@/components/modals/TestPhoneNotificationModal'
import { NotificationForm } from './NotificationForm'
import { Footer } from './components/Footer'

import type { NotificationFormType } from '@/notificationForms'
import type { NotificationFormValues } from './types'

import { form } from './formState'
import { getFormFields } from './initailFormFields'

type Props = {
  onSubmit: (formValues: NotificationFormValues) => void
  values: NotificationFormValues
  notification: NotificationFormType
  cancel: () => void
  subtitle: string
  title: string
}

export function NotificationFormProvider(props: Props) {
  const { title, subtitle, values, cancel, onSubmit, notification } = props

  const [formData, setFormData] = useState<NotificationFormValues>(values)

  const configs = useMemo<FormConfig<NotificationFormValues>>(
    () => ({
      id: 'notification-form',
      initialValues: values,
      fields: getFormFields(values, notification),
    }),
    [values, notification],
  )

  const { Modal: PhoneModal, show: showPhoneTestNotificationModal } =
    useTestPhoneNotificationModal()
  const { Modal: EmailModal, show: showEmailTestNotificationModal } =
    useTestEmailNotificationModal()

  const onTest = (form: NotificationFormValues) => {
    setFormData(form)
    if (form.notificationWay === 'PHONE') {
      showPhoneTestNotificationModal()
    } else {
      showEmailTestNotificationModal()
    }
  }

  const Modal = formData.notificationWay === 'PHONE' ? PhoneModal : EmailModal

  return (
    <>
      <form.Form
        title={title}
        subtitle={subtitle}
        footer={<Footer onCancel={cancel} onTest={onTest} />}
        onSubmit={onSubmit}
        config={configs}
        requireTransaction={false}
        stopEditingOnUnmount
        applyPendingFitMapOnMount={false}
      >
        <NotificationForm notification={notification} />
      </form.Form>

      <Modal notification={notification} values={formData} />
    </>
  )
}
